import { render, staticRenderFns } from "./new-driver-password-form.vue?vue&type=template&id=74f8f919&scoped=true&"
import script from "./new-driver-password-form.vue?vue&type=script&lang=js&"
export * from "./new-driver-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8f919",
  null
  
)

export default component.exports